import { Injectable, EventEmitter, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class ProductPanelService {

  uiModel: any = {
    isModalShown: new BehaviorSubject<boolean>(false),
    rightPanelMoved: false,
  };

  model: any = {
    segment: '',
    nextSegment: '',
  };

  @Output() toggleProductPanel: EventEmitter<any> = new EventEmitter<any>();

  fetchComments(params?: any): Promise<any> {
    const testData = new Array(26);
    return Promise.resolve(testData).then((data) => {
      return data;
    });
  }

  toggleProductPanelModal(toggle: boolean, segmentName: string, data?: any): void {
    this.toggleProductPanel.emit({ toggle, segmentName, data });
  }

  setIsModalShown(value: boolean) {
    this.uiModel.isModalShown.next(value);
  }
}
